import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";
import { getAuthApiClient } from "@shared/apis/sidekick/api-factories";
import { DirectOAuth2AuthorizeResponse } from "@shared/apis/sidekick/generated";
import { useMutation } from "@tanstack/react-query";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess: (data: DirectOAuth2AuthorizeResponse) => void;
  onError?: (error: any) => void;
};

type Params = {
  clientId: string;
  redirectUri: string;
  scope: string;
  state?: string | null;
  responseType: string;
};

export const useDirectOAuth2Authorize = (props: Props) => {
  const { onSuccess, onError } = props;
  const api = getAuthApiClient();

  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.authControllerOauth2DirectAuthorize({
        clientId: params.clientId,
        redirectUri: params.redirectUri,
        scope: params.scope,
        state: params.state,
        responseType: params.responseType,
      });
      onSuccess(response);
      return response;
    },
    onError: async (e) => {
      console.error(`Failed to complete the authorization flow`, e);
      const error = await apiResponseErrorHandler(e);
      onError?.(error);
      if (error.status === 403) {
        toast.error("You need to login to continue.");
        return;
      }
      toast.error(error.errors[0]);
    },
  });

  return mutation;
};
